export enum UrlQueryOperatorKey {
  GREATER_THAN = 'gt',
  LESS_THAN = 'lt',
  EQUAL_TO = 'eq',
  NOT_EQUAL_TO = 'neq',
  GREATER_THAN_EQUAL_TO = 'gteq',
  LESS_THAN_EQUAL_TO = 'lteq',
  BETWEEN = 'btw',
  NOT_BETWEEN = 'nbtw',
  IN = 'in',
  NOT_IN = 'nin',
  ENCRYPTED = 'enct',
  CONTAINS = 'contains'
}
